import axios from "./http";

//设置超时时间
axios.defaults.timeout = 15000;

function dingtalk_student_sync(){
    return axios.put("/dingtalk/student/sync")
}

export default {
    dingtalk_student_sync
}
